import ActionMenu, {
  ActionMenuItem,
} from "../../../../../components/actionMenu/ActionMenu";
import userRoles from "../../../../../constants/userRoles";
import { fetchDownloadCmr } from "../../../../../redux/api/raports.api";
import { useAppDispatch } from "../../../../../redux/hooks";
import { ActiveTransportsDataInterface } from "../../../../../redux/interfaces/transport.interface";
import { setSelectedActiveTransport } from "../../../../../redux/reducer/raports.reducer";
import usePermissions from "../../../../../router/usePermissions";

function ActiveTransportActionButton({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: ActiveTransportsDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();
  const { isAuthorized } = usePermissions();

  const { id_ruta_intranod } = crudData;

  const END_ACTIVE_TRANSPORT = isAuthorized(userRoles.END_ACTIVE_TRANSPORT);

  const handleDownloadCmr = () => {
    if (id_ruta_intranod && itemId) {
      dispatch(
        fetchDownloadCmr({
          idTransport: itemId,
        }),
      );
    }
  };

  const handleEndTransport = () => {
    if (!END_ACTIVE_TRANSPORT) return;
    dispatch(setSelectedActiveTransport(crudData));
  };

  const items: ActionMenuItem[] = [
    {
      id: "download-cmr",
      label: "Descarca CMR",
      icon: "DOCUMENTS",
      kind: "download",
      section: "browse",
      tooltip:
        id_ruta_intranod && itemId
          ? "Descarca documentul CMR al transportului."
          : "CMR este disponibil dupa asocierea transportului cu o ruta intranod.",
      disabled: !id_ruta_intranod || !itemId,
      onClick: handleDownloadCmr,
    },
    {
      id: "end-transport",
      label: "Finalizeaza transportul",
      icon: "VALIDATE",
      color: "error",
      section: "danger",
      tooltip: "Deschide formularul de finalizare a transportului.",
      hidden: !END_ACTIVE_TRANSPORT,
      onClick: handleEndTransport,
    },
  ];

  return (
    <ActionMenu
      items={items}
      minItemsForMenu={2}
      title={String(itemId)}
      ariaLabel={`Actiuni pentru transportul ${itemId}`}
    />
  );
}

export default ActiveTransportActionButton;
